<template>
    <div class="user-invoice">
        <UserInvoice></UserInvoice>
    </div>
</template>

<script>
import UserInvoice from '../../components/address/UserInvoice.vue';

export default {
    name: 'user-invoice',
    components: {
        UserInvoice,
    },
};
</script>

<style lang="less" scoped>
</style>